module.exports = __webpack_public_path__ + "files/Bulletin labos 7-10.b696185fb235470d1f0fecb6de86f1c0.pdf";